var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-mermaid',{attrs:{"nodes":_vm.statesData,"type":"graph LR"},on:{"nodeClick":_vm.editNode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }